var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", [
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("datepicker", {
          attrs: {
            inline: true,
            language: _vm.languages["de"],
            placeholder: "Datum",
            format: _vm.dateFormat,
          },
          model: {
            value: _vm.appointmentDate,
            callback: function ($$v) {
              _vm.appointmentDate = $$v
            },
            expression: "appointmentDate",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group mb-3" },
      [
        _c("timepicker", {
          staticClass: "form-control",
          model: {
            value: _vm.appointmentTime,
            callback: function ($$v) {
              _vm.appointmentTime = $$v
            },
            expression: "appointmentTime",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mb-3" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.appointmentSubject,
            expression: "appointmentSubject",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "text", placeholder: "Thema" },
        domProps: { value: _vm.appointmentSubject },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.appointmentSubject = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-primary",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.submitAppointment.apply(null, arguments)
          },
        },
      },
      [_vm._v("\n     Weiter ...\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }